module.exports = __webpack_public_path__ + "images/patterns/light/BrickDiagonal.c08919b70c8238d07403.svg";